import {fullAccessRolesOrganization} from "../../../Constants";

export const menuData = [
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        type: "myOrders",
        name: "Мои заказы"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        type: "mySamples",
        name: "Мои шаблоны"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        type: "systemSamples",
        name: "Шаблоны системы"
    },
    {roles: ["ROLE_ORGANIZATION_USER_ACCEPTING", ...fullAccessRolesOrganization], type: "calculation", name: "Расчеты"},
    {
        roles: ["ROLE_ORGANIZATION_USER_ORDERS", ...fullAccessRolesOrganization],
        type: "orders",
        name: "Заказы"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        type: "optimization",
        name: "Оптимизация"
    },
    {roles: ["ROLE_ORGANIZATION_USER_MATERIAL_USER", ...fullAccessRolesOrganization], type: "storage", name: "Склад"},
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", "ROLE_ORGANIZATION_USER_CUT", ...fullAccessRolesOrganization],
        type: "cutting",
        name: "Раскрой"
    },
    {roles: ["ROLE_ORGANIZATION_USER", ...fullAccessRolesOrganization], type: "production", name: "Производство"},
    {roles: ["ROLE_ONE_ORGANIZATION_USER"], type: "customer-production", name: "Производство"},
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        type: "economic",
        name: "Экономика"
    },
]

export const subMenuData = [
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        menuType: "myOrders",
        type: "customerOrders",
        name: "Заказы",
        hrefs: "/customer/orders"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        menuType: "myOrders",
        type: "customerArchive",
        name: "Архив",
        hrefs: "/customer/archive"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        menuType: "mySamples",
        type: "customerSamples",
        name: "Шаблоны",
        hrefs: "/customer/samples"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        menuType: "mySamples",
        type: "customerSamplesGroup",
        name: "Группы",
        hrefs: "/customer/groups"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        menuType: "mySamples",
        type: "customerSamplesEdges",
        name: "Кромки",
        hrefs: "/customer/samples/edges"
    },
    {
        roles: ["ROLE_CUSTOMER_USER", "ROLE_CUSTOMER_CREATOR", "ROLE_CUSTOMER_USER_SETTINGS"],
        menuType: "systemSamples",
        type: "customerSystemSamples",
        name: "Шаблоны",
        hrefs: "/customer/system-samples"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ACCEPTING", ...fullAccessRolesOrganization],
        menuType: "calculation",
        type: "ordersCloud",
        name: "Заказы из облака",
        hrefs: "/organization/orders-cloud"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ACCEPTING", ...fullAccessRolesOrganization],
        menuType: "calculation",
        type: "ordersComposition",
        name: "Композиции",
        hrefs: "/organization/orders-composition"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ACCEPTING", ...fullAccessRolesOrganization],
        menuType: "calculation",
        type: "calculationRequestsCutting",
        name: "Заявки на раскрой",
        hrefs: "/organization/requests-cutting/Calculation"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ACCEPTING", ...fullAccessRolesOrganization],
        menuType: "calculation",
        type: "calculationOptimizations",
        name: "Оптимизации на просчет",
        hrefs: "/organization/optimizations-calculation"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ACCEPTING", ...fullAccessRolesOrganization],
        menuType: "calculation",
        type: "calculationWorkingCuttingMaps",
        name: "Карты раскроя на просчет",
        hrefs: "/organization/working-cutting-maps-calculation"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ORDERS", ...fullAccessRolesOrganization],
        menuType: "orders",
        type: "orders",
        name: "Заказы",
        hrefs: "/organization/orders"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ORDERS", ...fullAccessRolesOrganization],
        menuType: "orders",
        type: "ordersConstructors",
        name: "Проектирование",
        hrefs: "/organization/constructors"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ORDERS", ...fullAccessRolesOrganization],
        menuType: "orders",
        type: "ordersConstructorsDeveloped",
        name: "Разработано",
        hrefs: "/organization/constructors/developed"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ORDERS", ...fullAccessRolesOrganization],
        menuType: "orders",
        type: "ordersPlanning",
        name: "Планирование",
        hrefs: "/organization/planning"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ARCHIVE", ...fullAccessRolesOrganization],
        menuType: "orders",
        type: "ordersOrdersToArchive",
        name: "На списание",
        hrefs: "/organization/for-write-off"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ARCHIVE", ...fullAccessRolesOrganization],
        menuType: "orders",
        type: "ordersOrdersArchive",
        name: "Архив",
        hrefs: "/organization/archive"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        menuType: "optimization",
        type: "optimizationRequestsCutting",
        name: "Заявки на раскрой",
        hrefs: "/organization/requests-cutting"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        menuType: "optimization",
        type: "optimizationPlan",
        name: "Планы",
        hrefs: "/organization/plans"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        menuType: "optimization",
        type: "optimizationOptimization",
        name: "Оптимизации",
        hrefs: "/organization/optimizations"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        menuType: "optimization",
        type: "optimizationDetailWarehouse",
        name: "Складские детали",
        hrefs: "/organization/detail-warehouse"
    },

    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        menuType: "optimization",
        type: "optimizationDetailReserve",
        name: "Резервы деталей",
        hrefs: "/organization/detail-reserve"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "ordersOrdersToArchive",
        name: "Материалы",
        hrefs: "/organization/materials"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_ISSUE_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "storageRequestsPurchase",
        name: "Заявки на закупку",
        hrefs: "/organization/requests-purchase"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_SUPER_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "storageReservationPieceMaterial",
        name: "Резервирование фурнитуры",
        hrefs: "/organization/reservation-piece-material"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_SUPER_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "storageReservationSlabMaterial",
        name: "Резервирование плитных материалов",
        hrefs: "/organization/reservation-slab-material"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_SUPER_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "storageStorageReservationLinearMaterial",
        name: "Резервирование погонных материалов",
        hrefs: "/organization/reservation-linear-material"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_SUPER_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "storageStorageMaterialsArrival",
        name: "Заявки на поставку",
        hrefs: "/organization/materials-arrival"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_USER", ...fullAccessRolesOrganization],
        menuType: "storage",
        type: "storageStorageCurrentCurrencies",
        name: "Курсы валют",
        hrefs: "/organization/current-currencies"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", ...fullAccessRolesOrganization],
        menuType: "cutting",
        type: "cuttingWorkingCuttingMaps",
        name: "Карты раскроя",
        hrefs: "/organization/working-cutting-maps"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_OPTIMIZATION", "ROLE_ORGANIZATION_USER_CUT", ...fullAccessRolesOrganization],
        menuType: "cutting",
        type: "cuttingQueueCuttingMaps",
        name: "Порядок раскроя",
        hrefs: "/organization/queue-cutting-maps"
    },

    {
        roles: ["ROLE_ORGANIZATION_USER", ...fullAccessRolesOrganization],
        menuType: "production",
        type: "productionProduction",
        name: "Производство",
        hrefs: "/organization/orders-production"
    },
    {
        roles: ["ROLE_ONE_ORGANIZATION_USER", ...fullAccessRolesOrganization],
        menuType: "customer-production",
        type: "productionCustomerProduction",
        name: "Производство",
        hrefs: "/customer/orders-production"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_ISSUE_USER", ...fullAccessRolesOrganization],
        menuType: "production",
        type: "productionIssuingEdges",
        name: "Выдача производсвенных материалов",
        hrefs: "/organization/issuing-edges",
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_MATERIAL_ISSUE_USER", ...fullAccessRolesOrganization],
        menuType: "production",
        type: "productionIssuancePieceMaterials",
        name: "Выдача штучных материалов",
        hrefs: "/organization/issuance-piece-materials"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "economicOrders",
        name: "Заказы",
        hrefs: "/organization/orders/economic"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "planningEconomic",
        name: "Планирование",
        hrefs: "/organization/economic/planning"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "notConstructedEconomic",
        name: "Не разработано",
        hrefs: "/organization/economic/not-constructed"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "economicIssuanceMaterialReserve",
        name: "Выдачи",
        hrefs: "/organization/issuance-material-reserve"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "economicInWork",
        name: "В работе",
        hrefs: "/organization/in-work"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "economicInStock",
        name: "На складе",
        hrefs: "/organization/in-stock"
    },
    {
        roles: ["ROLE_ORGANIZATION_USER_ECONOMICS", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "economicBalanceSheet",
        name: "Оборотная ведомость",
        hrefs: "/organization/balance-sheet"
    },

    {
        roles: ["ROLE_ORGANIZATION_USER_SALARY", ...fullAccessRolesOrganization],
        menuType: "economic",
        type: "economicSalary",
        name: "Заработная плата",
        hrefs: "/organization/salary"
    },
]
